export default __webpack_public_path__ + "static/media/EmptyFavorite.d9e8428b.png";